<template>
  <div class="basic_wrap moneybag-page">
    <div class="red_top_bg page-top">
      <div class="big_tit">
        {{ $t('moneybag.myWallet') }}
      </div>
    </div>

    <div class="hellotitle">
      {{ $t('c3.well') }} , {{ userName }}
    </div>

    <section class="wallet-card">
      <div
        v-if="vip"
        class="vip-pill"
      >
        {{ vip.name }}
      </div>
      <p class="balance-label">
        {{ $t('sky.jifen') }}
      </p>
      <strong class="balance-value">
        {{ funds }}
      </strong>
    </section>

    <div class="btn_box">
      <button
        type="button"
        class="wallet-btn is-primary"
        @click="$router.push('/cash')"
      >
        {{ $t('moneybag.withdraw') }}
      </button>
      <button
        type="button"
        class="wallet-btn is-primary"
        @click="$router.push('/invest')"
      >
        {{ $t('moneybag.recharge') }}
      </button>
    </div>

    <div class="manager_box">
      <div
        class="manager-row"
        @click="$router.push('/addcountUsdt')"
      >
        <div class="manager-main">
          <span class="manager-icon">
            <img src="../images/ban1/link.png">
          </span>
          <span>{{ $t('account.add') }}</span>
        </div>
        <img
          class="manager-arrow"
          src="../images/ban1/right.png"
        >
      </div>
      <div
        class="manager-row"
        @click="$router.push('/funds')"
      >
        <div class="manager-main">
          <span class="manager-icon">
            <img src="../images/ban1/time.png">
          </span>
          <span>{{ $t('moneybag.myWallet') }}</span>
        </div>
        <img
          class="manager-arrow"
          src="../images/ban1/right.png"
        >
      </div>
    </div>
  </div>
</template>

<script>
import Fetch from "../../utils/fetch";

export default {
	name: "Moneybag",
	data() {
		return {
			lang: this.$i18n.locale || "zh_cn",
			data: [],
			vip: null,
			list: {},
			account: 0,
			option: [],
			listShow: false,
			funds: 0,
			frozen: 0,
			mymoney: 0,
			userName: "",
		};
	},
	created() {
		this.$parent.footer("moneybag");
	},
	mounted() {
		Fetch("/user/funds").then(r => {
			this.option.push({
				text: this.$t("moneybag.types"),
				value: 0,
			});

			for (var key in r.data.reason) {
				r.data.reason[key] = this.translateReason(key, r.data.reason[key]);
				this.option.push({
					text: r.data.reason[key],
					value: key,
				});
			}

			this.showError(r.data.list.length);
			this.data = r.data.list;
			this.funds = (1 * r.data.money + 1 * r.data.wx_bankbz).toFixed(2);
			this.mymoney = r.data.mymoney;
			this.frozen = r.data.basemoney;
			this.userName = r.data.username;
			this.listd(1);

			if (r.data && r.data.vip) {
				this.vip = r.data.vip;
			}
		});
	},
	methods: {
		translateReason(key, fallback) {
			switch (key) {
			case "1":
				return this.$t("moneybag.recharge");
			case "2":
				return this.$t("moneybag.withdraw");
			case "3":
				return this.$t("moneybag.give");
			case "4":
				return this.$t("moneybag.signIn");
			case "5":
				return this.$t("moneybag.share");
			case "6":
				return this.$t("moneybag.purchase");
			case "7":
				return this.$t("moneybag.redPacket");
			case "8":
				return this.$t("moneybag.reward");
			case "9":
				return this.$t("moneybag.welfare");
			case "10":
				return this.$t("moneybag.invite");
			case "11":
			case "12":
				return this.$t("moneybag.income");
			default:
				return fallback;
			}
		},
		listd(type) {
			var dataf = this.data || [];

			for (var index = 0; index < dataf.length; index++) {
				if (type === 1) {
					dataf[index].show = 1;
				} else if (type === 2) {
					dataf[index].show = dataf[index].reason_type != 3 && dataf[index].reason_type != 4 ? 1 : 0;
				} else {
					dataf[index].show = dataf[index].reason_type == 3 || dataf[index].reason_type == 4 ? 1 : 0;
				}
			}

			this.data = dataf;
		},
		chooseType(val) {
			if (val == 0) {
				Fetch("/user/funds").then(r => {
					this.data = r.data.list;
					this.showError(r.data.list.length);
				});
			} else {
				Fetch("/user/funds", {
					reason_id: val,
				}).then(r => {
					this.data = r.data.list;
					this.showError(r.data.list.length);
				});
			}
		},
		showError(len) {
			this.listShow = len === 0;
		},
	},
};
</script>

<style lang="less" scoped>
.moneybag-page {
	min-height: 100vh;
	background: #111;
	color: #f6f6f6;
	padding-bottom: 100px;
	box-sizing: border-box;
}

.page-top {
	height: 44px;
	background: #111;
	color: #f6f6f6;
	border-bottom: 1px solid #242424;
	box-sizing: border-box;

	.big_tit {
		color: #f6f6f6;
	}
}

.hellotitle {
	margin: 18px 16px 0;
	color: #8ea0ff;
	font-size: 16px;
	font-weight: 700;
	line-height: 24px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.wallet-card {
	position: relative;
	margin: 14px 16px 0;
	padding: 26px 18px 24px;
	border-radius: 12px;
	border: 1px solid #303030;
	background: #222;
	box-shadow: 0 12px 22px rgba(0, 0, 0, 0.22);
	text-align: center;
	box-sizing: border-box;
}

.vip-pill {
	position: absolute;
	top: 14px;
	right: 14px;
	max-width: 46%;
	padding: 5px 12px;
	border-radius: 12px;
	background: rgba(101, 123, 233, 0.16);
	color: #12ed72;
	font-size: 12px;
	font-weight: 700;
	line-height: 16px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	box-sizing: border-box;
}

.balance-label {
	color: #c6cad2;
	font-size: 14px;
	line-height: 20px;
}

.balance-value {
	display: block;
	margin-top: 12px;
	color: #8ea0ff;
	font-size: 28px;
	font-weight: 700;
	line-height: 34px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.btn_box {
	margin: 16px 16px 0;
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 12px;
}

.wallet-btn {
	height: 42px;
	border: 1px solid #343434;
	border-radius: 10px;
	background: #1f1f1f;
	color: #8ea0ff;
	font-size: 14px;
	font-weight: 700;
	line-height: 20px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.wallet-btn.is-primary {
	background: linear-gradient(100deg, #657be9 0%, #8c52bd 100%) !important;
}

.manager_box {
	margin: 18px 16px 0;
	overflow: hidden;
	border-radius: 12px;
	border: 1px solid #303030;
	background: #222;
	box-shadow: 0 12px 22px rgba(0, 0, 0, 0.22);
}

.manager-row {
	min-height: 58px;
	padding: 0 16px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-bottom: 1px solid #303030;
	box-sizing: border-box;
}

.manager-row:last-child {
	border-bottom: 0;
}

.manager-main {
	min-width: 0;
	display: flex;
	align-items: center;
	color: #f6f6f6;
	font-size: 14px;
	line-height: 20px;
}

.manager-main span:last-child {
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.manager-icon {
	width: 32px;
	height: 32px;
	margin-right: 12px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	background: rgba(101, 123, 233, 0.18);
	flex: 0 0 32px;
}

.manager-icon img {
	width: 18px;
	height: 18px;
	object-fit: contain;
	filter: brightness(1.1);
}

.manager-arrow {
	width: 8px;
	height: 14px;
	margin-left: 12px;
	opacity: 0.52;
	filter: invert(1);
}


.basic_btn,
.history_coupon,
.wallet-btn.is-primary,
.allbtn {
  border: 0;
  background: linear-gradient(100deg, #657be9 0%, #8c52bd 100%) !important;
  color: #fff;
}


.page-top {
  background: #101010;
}

@media screen and (max-width: 374px) {
	.hellotitle,
	.wallet-card,
	.btn_box,
	.manager_box {
		margin-right: 12px;
		margin-left: 12px;
	}

	.balance-value {
		font-size: 24px;
	}

	.vip-pill {
		max-width: 42%;
	}
}
</style>
